import { BASE_PATH as U, BaseAPI as _, operationServerMap as m } from "../base.js";
import { DUMMY_BASE_URL as v, assertParamExists as i, createRequestFunction as V, serializeDataIfNeeded as S, setSearchParams as u, toPathString as I } from "../common.js";
import O from "axios";
var P = function(a) {
  return {
    merchantUserAdd: async (n, t = {}) => {
      i("merchantUserAdd", "merchantUserDTO", n);
      const o = new URL("/merchant_user", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserApplyShop: async (n, t = {}) => {
      i("merchantUserApplyShop", "merchantUserShopApplyVO", n);
      const o = new URL("/merchant_user/apply_shop", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserBind: async (n, t, o = {}) => {
      i("merchantUserBind", "shopId", n), i("merchantUserBind", "merchantUserBindVO", t);
      const r = "/merchant_user/bind/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), e = new URL(r, v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...o
      }, h = {}, c = {};
      h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...o.headers
      }, l.data = S(t, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserBindManager: async (n, t, o = {}) => {
      i("merchantUserBindManager", "shopId", n), i("merchantUserBindManager", "merchantUserBindVO", t);
      const r = "/merchant_user/bind_manager/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), e = new URL(r, v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...o
      }, h = {}, c = {};
      h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...o.headers
      }, l.data = S(t, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserBindManagerWithWxPhone: async (n, t, o = {}) => {
      i("merchantUserBindManagerWithWxPhone", "shopId", n), i("merchantUserBindManagerWithWxPhone", "merchantUserWxPhoneManagerBindRequest", t);
      const r = "/merchant_user/bind_manager_wx_phone/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), e = new URL(r, v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...o
      }, h = {}, c = {};
      h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...o.headers
      }, l.data = S(t, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserBindWithWxPhone: async (n, t, o = {}) => {
      i("merchantUserBindWithWxPhone", "shopId", n), i("merchantUserBindWithWxPhone", "merchantUserWxPhoneBindRequest", t);
      const r = "/merchant_user/bind_wx_phone/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), e = new URL(r, v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...o
      }, h = {}, c = {};
      h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...o.headers
      }, l.data = S(t, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserChangeBind: async (n, t, o = {}) => {
      i("merchantUserChangeBind", "shopId", n), i("merchantUserChangeBind", "changeUserBindCommand", t);
      const r = "/merchant_user/change_bind/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), e = new URL(r, v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...o
      }, h = {}, c = {};
      h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...o.headers
      }, l.data = S(t, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserClearCache: async (n, t = {}) => {
      i("merchantUserClearCache", "corpUserId", n);
      const o = new URL("/merchant_user/clear_cache", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, s = {}, l = {};
      n !== void 0 && (l.corpUserId = n), u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, {
        url: I(o),
        options: e
      };
    },
    merchantUserDeleteById: async (n, t = {}) => {
      i("merchantUserDeleteById", "merchantUserId", n);
      const o = "/merchant_user/{merchantUserId}".replace("{merchantUserId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "DELETE",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserEdit: async (n, t = {}) => {
      i("merchantUserEdit", "merchantUserDTO", n);
      const o = new URL("/merchant_user", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserEditStatus: async (n, t = {}) => {
      i("merchantUserEditStatus", "merchantUserEditVO", n);
      const o = new URL("/merchant_user/edit_status", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserGetBindStatus: async (n, t = {}) => {
      i("merchantUserGetBindStatus", "shopId", n);
      const o = new URL("/merchant_user/bind-status", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...t
      }, s = {}, l = {};
      n !== void 0 && (l.shopId = n), u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, {
        url: I(o),
        options: e
      };
    },
    merchantUserGetPage: async (n, t, o = {}) => {
      i("merchantUserGetPage", "merchantUser", n), i("merchantUserGetPage", "page", t);
      const r = new URL("/merchant_user/page", v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...o
      }, l = {}, h = {};
      if (n !== void 0) for (const [d, y] of Object.entries(n)) h[d] = y;
      if (t !== void 0) for (const [d, y] of Object.entries(t)) h[d] = y;
      u(r, h);
      let c = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...c,
        ...o.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserGetSuperAdmin: async (n, t = {}) => {
      i("merchantUserGetSuperAdmin", "shopId", n);
      const o = "/merchant_user/super_admin/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserGetUserDetailListByShopId: async (n, t = {}) => {
      i("merchantUserGetUserDetailListByShopId", "shopId", n);
      const o = "/merchant_user/detail_list_by_shop_id/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserGetUserListByRoleId: async (n, t = {}) => {
      i("merchantUserGetUserListByRoleId", "roleId", n);
      const o = "/merchant_user/list_by_role/{roleId}".replace("{roleId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserGetUserListByShopId: async (n, t, o = {}) => {
      i("merchantUserGetUserListByShopId", "shopId", n), i("merchantUserGetUserListByShopId", "requestBody", t);
      const r = "/merchant_user/list_by_shop_id/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), e = new URL(r, v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...o
      }, h = {}, c = {};
      h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...o.headers
      }, l.data = S(t, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserGetUserRolesInfo: async (n = {}) => {
      const t = new URL("/merchant_user/role_info", v);
      let o;
      a && (o = a.baseOptions);
      const r = {
        method: "GET",
        ...o,
        ...n
      }, e = {};
      u(t, {});
      let s = o && o.headers ? o.headers : {};
      return r.headers = {
        ...e,
        ...s,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantUserGetUserShopInfo: async (n = {}) => {
      const t = new URL("/merchant_user/user_shop_info", v);
      let o;
      a && (o = a.baseOptions);
      const r = {
        method: "GET",
        ...o,
        ...n
      }, e = {};
      u(t, {});
      let s = o && o.headers ? o.headers : {};
      return r.headers = {
        ...e,
        ...s,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantUserHasLoginPermission: async (n, t = {}) => {
      i("merchantUserHasLoginPermission", "corpUserId", n);
      const o = new URL("/merchant_user/has_login_permission", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...t
      }, s = {}, l = {};
      n !== void 0 && (l.corpUserId = n), u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, {
        url: I(o),
        options: e
      };
    },
    merchantUserIsOpenShop: async (n = {}) => {
      const t = new URL("/merchant_user/is_open_shop", v);
      let o;
      a && (o = a.baseOptions);
      const r = {
        method: "GET",
        ...o,
        ...n
      }, e = {};
      u(t, {});
      let s = o && o.headers ? o.headers : {};
      return r.headers = {
        ...e,
        ...s,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantUserQueryByCorpUserId: async (n, t, o, r = {}) => {
      i("merchantUserQueryByCorpUserId", "corpUserId", n);
      const e = "/merchant_user/corp_user_id/{corpUserId}".replace("{corpUserId}", encodeURIComponent(String(n))), s = new URL(e, v);
      let l;
      a && (l = a.baseOptions);
      const h = {
        method: "GET",
        ...l,
        ...r
      }, c = {}, d = {};
      t !== void 0 && (d.shopId = t), o !== void 0 && (d.merchantUserId = o), u(s, d);
      let y = l && l.headers ? l.headers : {};
      return h.headers = {
        ...c,
        ...y,
        ...r.headers
      }, {
        url: I(s),
        options: h
      };
    },
    merchantUserQueryById: async (n, t = {}) => {
      i("merchantUserQueryById", "merchantUserId", n);
      const o = "/merchant_user/{merchantUserId}".replace("{merchantUserId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserQueryInfoByCorpUserId: async (n, t, o, r = {}) => {
      i("merchantUserQueryInfoByCorpUserId", "corpUserId", n);
      const e = "/merchant_user/corp_user_id/{corpUserId}/info".replace("{corpUserId}", encodeURIComponent(String(n))), s = new URL(e, v);
      let l;
      a && (l = a.baseOptions);
      const h = {
        method: "GET",
        ...l,
        ...r
      }, c = {}, d = {};
      t !== void 0 && (d.shopId = t), o !== void 0 && (d.merchantUserId = o), u(s, d);
      let y = l && l.headers ? l.headers : {};
      return h.headers = {
        ...c,
        ...y,
        ...r.headers
      }, {
        url: I(s),
        options: h
      };
    },
    merchantUserQueryInfoByCorpUserIdV2: async (n, t, o, r = {}) => {
      i("merchantUserQueryInfoByCorpUserIdV2", "corpUserId", n);
      const e = "/merchant_user/corp_user_id/{corpUserId}/info_v2".replace("{corpUserId}", encodeURIComponent(String(n))), s = new URL(e, v);
      let l;
      a && (l = a.baseOptions);
      const h = {
        method: "GET",
        ...l,
        ...r
      }, c = {}, d = {};
      t !== void 0 && (d.shopId = t), o !== void 0 && (d.merchantUserId = o), u(s, d);
      let y = l && l.headers ? l.headers : {};
      return h.headers = {
        ...c,
        ...y,
        ...r.headers
      }, {
        url: I(s),
        options: h
      };
    },
    merchantUserQueryInfoByUserId: async (n, t = {}) => {
      i("merchantUserQueryInfoByUserId", "userId", n);
      const o = "/merchant_user/user_id/{userId}/info".replace("{userId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserSaveWithRole: async (n, t = {}) => {
      i("merchantUserSaveWithRole", "merchantUserCreateVo", n);
      const o = new URL("/merchant_user/save_with_role", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserUpdateName: async (n, t = {}) => {
      i("merchantUserUpdateName", "merchantUserDTO", n);
      const o = new URL("/merchant_user/update_name", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserUpdateWithRole: async (n, t = {}) => {
      i("merchantUserUpdateWithRole", "merchantUserCreateVo", n);
      const o = new URL("/merchant_user/update_with_role", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserV2ApplyShop: async (n, t = {}) => {
      i("merchantUserV2ApplyShop", "merchantUserShopApplyCommand", n);
      const o = new URL("/v2/merchant_user/apply_shop", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserV2Bind: async (n, t, o = {}) => {
      i("merchantUserV2Bind", "shopId", n), i("merchantUserV2Bind", "merchantUserBindCommand", t);
      const r = "/v2/merchant_user/bind/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), e = new URL(r, v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...o
      }, h = {}, c = {};
      h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...o.headers
      }, l.data = S(t, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserV2BindManager: async (n, t, o = {}) => {
      i("merchantUserV2BindManager", "shopId", n), i("merchantUserV2BindManager", "merchantUserBindCommand", t);
      const r = "/v2/merchant_user/bind_manager/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), e = new URL(r, v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...o
      }, h = {}, c = {};
      h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...o.headers
      }, l.data = S(t, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserV2DeleteById: async (n, t = {}) => {
      i("merchantUserV2DeleteById", "merchantUserId", n);
      const o = "/v2/merchant_user/{merchantUserId}".replace("{merchantUserId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "DELETE",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserV2Edit: async (n, t = {}) => {
      i("merchantUserV2Edit", "merchantUserDTO", n);
      const o = new URL("/v2/merchant_user", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserV2EditStatus: async (n, t = {}) => {
      i("merchantUserV2EditStatus", "userUpdateStatusCommand", n);
      const o = new URL("/v2/merchant_user/edit_status", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserV2GetBindStatus: async (n, t = {}) => {
      i("merchantUserV2GetBindStatus", "shopId", n);
      const o = new URL("/v2/merchant_user/bind-status", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...t
      }, s = {}, l = {};
      n !== void 0 && (l.shopId = n), u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, {
        url: I(o),
        options: e
      };
    },
    merchantUserV2GetPage: async (n, t, o = {}) => {
      i("merchantUserV2GetPage", "merchantUserDTO", n), i("merchantUserV2GetPage", "page", t);
      const r = new URL("/v2/merchant_user/page", v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...o
      }, l = {}, h = {};
      if (n !== void 0) for (const [d, y] of Object.entries(n)) h[d] = y;
      if (t !== void 0) for (const [d, y] of Object.entries(t)) h[d] = y;
      u(r, h);
      let c = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...c,
        ...o.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserV2GetSuperAdmin: async (n, t = {}) => {
      i("merchantUserV2GetSuperAdmin", "shopId", n);
      const o = "/v2/merchant_user/super_admin/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserV2GetUserDetailListByShopId: async (n, t = {}) => {
      i("merchantUserV2GetUserDetailListByShopId", "shopId", n);
      const o = "/v2/merchant_user/detail_list_by_shop_id/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserV2GetUserListByRoleId: async (n, t = {}) => {
      i("merchantUserV2GetUserListByRoleId", "roleId", n);
      const o = "/v2/merchant_user/list_by_role/{roleId}".replace("{roleId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserV2GetUserListByShopId: async (n, t, o = {}) => {
      i("merchantUserV2GetUserListByShopId", "shopId", n), i("merchantUserV2GetUserListByShopId", "requestBody", t);
      const r = "/v2/merchant_user/list_by_shop_id/{shopId}".replace("{shopId}", encodeURIComponent(String(n))), e = new URL(r, v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...o
      }, h = {}, c = {};
      h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...o.headers
      }, l.data = S(t, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserV2GetUserRolesInfo: async (n = {}) => {
      const t = new URL("/v2/merchant_user/role_info", v);
      let o;
      a && (o = a.baseOptions);
      const r = {
        method: "GET",
        ...o,
        ...n
      }, e = {};
      u(t, {});
      let s = o && o.headers ? o.headers : {};
      return r.headers = {
        ...e,
        ...s,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantUserV2GetUserShopInfo: async (n = {}) => {
      const t = new URL("/v2/merchant_user/user_shop_info", v);
      let o;
      a && (o = a.baseOptions);
      const r = {
        method: "GET",
        ...o,
        ...n
      }, e = {};
      u(t, {});
      let s = o && o.headers ? o.headers : {};
      return r.headers = {
        ...e,
        ...s,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantUserV2HasLoginPermission: async (n, t = {}) => {
      i("merchantUserV2HasLoginPermission", "corpUserId", n);
      const o = new URL("/v2/merchant_user/has_login_permission", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "GET",
        ...r,
        ...t
      }, s = {}, l = {};
      n !== void 0 && (l.corpUserId = n), u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, {
        url: I(o),
        options: e
      };
    },
    merchantUserV2IsOpenShop: async (n = {}) => {
      const t = new URL("/v2/merchant_user/is_open_shop", v);
      let o;
      a && (o = a.baseOptions);
      const r = {
        method: "GET",
        ...o,
        ...n
      }, e = {};
      u(t, {});
      let s = o && o.headers ? o.headers : {};
      return r.headers = {
        ...e,
        ...s,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantUserV2QueryByCorpUserId: async (n, t, o, r = {}) => {
      i("merchantUserV2QueryByCorpUserId", "corpUserId", n);
      const e = "/v2/merchant_user/corp_user_id/{corpUserId}".replace("{corpUserId}", encodeURIComponent(String(n))), s = new URL(e, v);
      let l;
      a && (l = a.baseOptions);
      const h = {
        method: "GET",
        ...l,
        ...r
      }, c = {}, d = {};
      t !== void 0 && (d.shopId = t), o !== void 0 && (d.merchantUserId = o), u(s, d);
      let y = l && l.headers ? l.headers : {};
      return h.headers = {
        ...c,
        ...y,
        ...r.headers
      }, {
        url: I(s),
        options: h
      };
    },
    merchantUserV2QueryInfoByCorpUserId: async (n, t, o, r = {}) => {
      i("merchantUserV2QueryInfoByCorpUserId", "corpUserId", n);
      const e = "/v2/merchant_user/corp_user_id/{corpUserId}/info".replace("{corpUserId}", encodeURIComponent(String(n))), s = new URL(e, v);
      let l;
      a && (l = a.baseOptions);
      const h = {
        method: "GET",
        ...l,
        ...r
      }, c = {}, d = {};
      t !== void 0 && (d.shopId = t), o !== void 0 && (d.merchantUserId = o), u(s, d);
      let y = l && l.headers ? l.headers : {};
      return h.headers = {
        ...c,
        ...y,
        ...r.headers
      }, {
        url: I(s),
        options: h
      };
    },
    merchantUserV2QueryInfoByCorpUserIdV2: async (n, t, o, r = {}) => {
      i("merchantUserV2QueryInfoByCorpUserIdV2", "corpUserId", n);
      const e = "/v2/merchant_user/corp_user_id/{corpUserId}/info_v2".replace("{corpUserId}", encodeURIComponent(String(n))), s = new URL(e, v);
      let l;
      a && (l = a.baseOptions);
      const h = {
        method: "GET",
        ...l,
        ...r
      }, c = {}, d = {};
      t !== void 0 && (d.shopId = t), o !== void 0 && (d.merchantUserId = o), u(s, d);
      let y = l && l.headers ? l.headers : {};
      return h.headers = {
        ...c,
        ...y,
        ...r.headers
      }, {
        url: I(s),
        options: h
      };
    },
    merchantUserV2QueryInfoByUserId: async (n, t = {}) => {
      i("merchantUserV2QueryInfoByUserId", "userId", n);
      const o = "/v2/merchant_user/user_id/{userId}/info".replace("{userId}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserV2SaveWithRole: async (n, t = {}) => {
      i("merchantUserV2SaveWithRole", "userCreateCommand", n);
      const o = new URL("/v2/merchant_user/save_with_role", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserV2UpdateName: async (n, t = {}) => {
      i("merchantUserV2UpdateName", "userUpdateNameCommand", n);
      const o = new URL("/v2/merchant_user/update_name", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserV2UpdateWithRole: async (n, t = {}) => {
      i("merchantUserV2UpdateWithRole", "userUpdateCommand", n);
      const o = new URL("/v2/merchant_user/update_with_role", v);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...t
      }, s = {}, l = {};
      s["Content-Type"] = "application/json", u(o, l);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...s,
        ...h,
        ...t.headers
      }, e.data = S(n, e, a), {
        url: I(o),
        options: e
      };
    },
    merchantUserV2VerifyPhone: async (n, t = {}) => {
      i("merchantUserV2VerifyPhone", "phone", n);
      const o = "/v2/merchant_user/verify_phone/{phone}".replace("{phone}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserV2WhiteOff: async (n = {}) => {
      const t = new URL("/v2/merchant_user/white_off", v);
      let o;
      a && (o = a.baseOptions);
      const r = {
        method: "POST",
        ...o,
        ...n
      }, e = {};
      u(t, {});
      let s = o && o.headers ? o.headers : {};
      return r.headers = {
        ...e,
        ...s,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantUserV2WhiteOffUser: async (n, t, o, r = {}) => {
      i("merchantUserV2WhiteOffUser", "body", n);
      const e = new URL("/v2/merchant_user/white_off_user", v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...r
      }, h = {}, c = {};
      t !== void 0 && (c.shopId = t), o !== void 0 && (c.merchantUserId = o), h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...r.headers
      }, l.data = S(n, l, a), {
        url: I(e),
        options: l
      };
    },
    merchantUserVerifyPhone: async (n, t = {}) => {
      i("merchantUserVerifyPhone", "phone", n);
      const o = "/merchant_user/verify_phone/{phone}".replace("{phone}", encodeURIComponent(String(n))), r = new URL(o, v);
      let e;
      a && (e = a.baseOptions);
      const s = {
        method: "GET",
        ...e,
        ...t
      }, l = {};
      u(r, {});
      let h = e && e.headers ? e.headers : {};
      return s.headers = {
        ...l,
        ...h,
        ...t.headers
      }, {
        url: I(r),
        options: s
      };
    },
    merchantUserWhiteOff: async (n = {}) => {
      const t = new URL("/merchant_user/white_off", v);
      let o;
      a && (o = a.baseOptions);
      const r = {
        method: "POST",
        ...o,
        ...n
      }, e = {};
      u(t, {});
      let s = o && o.headers ? o.headers : {};
      return r.headers = {
        ...e,
        ...s,
        ...n.headers
      }, {
        url: I(t),
        options: r
      };
    },
    merchantUserWhiteOffUser: async (n, t, o, r = {}) => {
      i("merchantUserWhiteOffUser", "body", n);
      const e = new URL("/merchant_user/white_off_user", v);
      let s;
      a && (s = a.baseOptions);
      const l = {
        method: "POST",
        ...s,
        ...r
      }, h = {}, c = {};
      t !== void 0 && (c.shopId = t), o !== void 0 && (c.merchantUserId = o), h["Content-Type"] = "application/json", u(e, c);
      let d = s && s.headers ? s.headers : {};
      return l.headers = {
        ...h,
        ...d,
        ...r.headers
      }, l.data = S(n, l, a), {
        url: I(e),
        options: l
      };
    }
  };
}, p = function(a) {
  const n = P(a);
  return {
    async merchantUserAdd(t, o) {
      var r, e;
      const s = await n.merchantUserAdd(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserAdd"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserApplyShop(t, o) {
      var r, e;
      const s = await n.merchantUserApplyShop(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserApplyShop"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserBind(t, o, r) {
      var e, s;
      const l = await n.merchantUserBind(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserBind"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserBindManager(t, o, r) {
      var e, s;
      const l = await n.merchantUserBindManager(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserBindManager"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserBindManagerWithWxPhone(t, o, r) {
      var e, s;
      const l = await n.merchantUserBindManagerWithWxPhone(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserBindManagerWithWxPhone"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserBindWithWxPhone(t, o, r) {
      var e, s;
      const l = await n.merchantUserBindWithWxPhone(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserBindWithWxPhone"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserChangeBind(t, o, r) {
      var e, s;
      const l = await n.merchantUserChangeBind(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserChangeBind"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserClearCache(t, o) {
      var r, e;
      const s = await n.merchantUserClearCache(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserClearCache"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserDeleteById(t, o) {
      var r, e;
      const s = await n.merchantUserDeleteById(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserDeleteById"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserEdit(t, o) {
      var r, e;
      const s = await n.merchantUserEdit(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserEdit"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserEditStatus(t, o) {
      var r, e;
      const s = await n.merchantUserEditStatus(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserEditStatus"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserGetBindStatus(t, o) {
      var r, e;
      const s = await n.merchantUserGetBindStatus(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserGetBindStatus"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserGetPage(t, o, r) {
      var e, s;
      const l = await n.merchantUserGetPage(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserGetPage"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserGetSuperAdmin(t, o) {
      var r, e;
      const s = await n.merchantUserGetSuperAdmin(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserGetSuperAdmin"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserGetUserDetailListByShopId(t, o) {
      var r, e;
      const s = await n.merchantUserGetUserDetailListByShopId(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserGetUserDetailListByShopId"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserGetUserListByRoleId(t, o) {
      var r, e;
      const s = await n.merchantUserGetUserListByRoleId(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserGetUserListByRoleId"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserGetUserListByShopId(t, o, r) {
      var e, s;
      const l = await n.merchantUserGetUserListByShopId(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserGetUserListByShopId"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserGetUserRolesInfo(t) {
      var o, r;
      const e = await n.merchantUserGetUserRolesInfo(t), s = (o = a == null ? void 0 : a.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = m["MerchantUserApi.merchantUserGetUserRolesInfo"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (h, c) => V(e, O, U, a)(h, l || c);
    },
    async merchantUserGetUserShopInfo(t) {
      var o, r;
      const e = await n.merchantUserGetUserShopInfo(t), s = (o = a == null ? void 0 : a.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = m["MerchantUserApi.merchantUserGetUserShopInfo"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (h, c) => V(e, O, U, a)(h, l || c);
    },
    async merchantUserHasLoginPermission(t, o) {
      var r, e;
      const s = await n.merchantUserHasLoginPermission(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserHasLoginPermission"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserIsOpenShop(t) {
      var o, r;
      const e = await n.merchantUserIsOpenShop(t), s = (o = a == null ? void 0 : a.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = m["MerchantUserApi.merchantUserIsOpenShop"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (h, c) => V(e, O, U, a)(h, l || c);
    },
    async merchantUserQueryByCorpUserId(t, o, r, e) {
      var s, l;
      const h = await n.merchantUserQueryByCorpUserId(t, o, r, e), c = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, d = (l = m["MerchantUserApi.merchantUserQueryByCorpUserId"]) === null || l === void 0 || (l = l[c]) === null || l === void 0 ? void 0 : l.url;
      return (y, B) => V(h, O, U, a)(y, d || B);
    },
    async merchantUserQueryById(t, o) {
      var r, e;
      const s = await n.merchantUserQueryById(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserQueryById"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserQueryInfoByCorpUserId(t, o, r, e) {
      var s, l;
      const h = await n.merchantUserQueryInfoByCorpUserId(t, o, r, e), c = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, d = (l = m["MerchantUserApi.merchantUserQueryInfoByCorpUserId"]) === null || l === void 0 || (l = l[c]) === null || l === void 0 ? void 0 : l.url;
      return (y, B) => V(h, O, U, a)(y, d || B);
    },
    async merchantUserQueryInfoByCorpUserIdV2(t, o, r, e) {
      var s, l;
      const h = await n.merchantUserQueryInfoByCorpUserIdV2(t, o, r, e), c = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, d = (l = m["MerchantUserApi.merchantUserQueryInfoByCorpUserIdV2"]) === null || l === void 0 || (l = l[c]) === null || l === void 0 ? void 0 : l.url;
      return (y, B) => V(h, O, U, a)(y, d || B);
    },
    async merchantUserQueryInfoByUserId(t, o) {
      var r, e;
      const s = await n.merchantUserQueryInfoByUserId(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserQueryInfoByUserId"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserSaveWithRole(t, o) {
      var r, e;
      const s = await n.merchantUserSaveWithRole(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserSaveWithRole"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserUpdateName(t, o) {
      var r, e;
      const s = await n.merchantUserUpdateName(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserUpdateName"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserUpdateWithRole(t, o) {
      var r, e;
      const s = await n.merchantUserUpdateWithRole(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserUpdateWithRole"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2ApplyShop(t, o) {
      var r, e;
      const s = await n.merchantUserV2ApplyShop(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2ApplyShop"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2Bind(t, o, r) {
      var e, s;
      const l = await n.merchantUserV2Bind(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserV2Bind"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserV2BindManager(t, o, r) {
      var e, s;
      const l = await n.merchantUserV2BindManager(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserV2BindManager"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserV2DeleteById(t, o) {
      var r, e;
      const s = await n.merchantUserV2DeleteById(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2DeleteById"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2Edit(t, o) {
      var r, e;
      const s = await n.merchantUserV2Edit(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2Edit"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2EditStatus(t, o) {
      var r, e;
      const s = await n.merchantUserV2EditStatus(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2EditStatus"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2GetBindStatus(t, o) {
      var r, e;
      const s = await n.merchantUserV2GetBindStatus(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2GetBindStatus"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2GetPage(t, o, r) {
      var e, s;
      const l = await n.merchantUserV2GetPage(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserV2GetPage"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserV2GetSuperAdmin(t, o) {
      var r, e;
      const s = await n.merchantUserV2GetSuperAdmin(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2GetSuperAdmin"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2GetUserDetailListByShopId(t, o) {
      var r, e;
      const s = await n.merchantUserV2GetUserDetailListByShopId(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2GetUserDetailListByShopId"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2GetUserListByRoleId(t, o) {
      var r, e;
      const s = await n.merchantUserV2GetUserListByRoleId(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2GetUserListByRoleId"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2GetUserListByShopId(t, o, r) {
      var e, s;
      const l = await n.merchantUserV2GetUserListByShopId(t, o, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, c = (s = m["MerchantUserApi.merchantUserV2GetUserListByShopId"]) === null || s === void 0 || (s = s[h]) === null || s === void 0 ? void 0 : s.url;
      return (d, y) => V(l, O, U, a)(d, c || y);
    },
    async merchantUserV2GetUserRolesInfo(t) {
      var o, r;
      const e = await n.merchantUserV2GetUserRolesInfo(t), s = (o = a == null ? void 0 : a.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = m["MerchantUserApi.merchantUserV2GetUserRolesInfo"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (h, c) => V(e, O, U, a)(h, l || c);
    },
    async merchantUserV2GetUserShopInfo(t) {
      var o, r;
      const e = await n.merchantUserV2GetUserShopInfo(t), s = (o = a == null ? void 0 : a.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = m["MerchantUserApi.merchantUserV2GetUserShopInfo"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (h, c) => V(e, O, U, a)(h, l || c);
    },
    async merchantUserV2HasLoginPermission(t, o) {
      var r, e;
      const s = await n.merchantUserV2HasLoginPermission(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2HasLoginPermission"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2IsOpenShop(t) {
      var o, r;
      const e = await n.merchantUserV2IsOpenShop(t), s = (o = a == null ? void 0 : a.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = m["MerchantUserApi.merchantUserV2IsOpenShop"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (h, c) => V(e, O, U, a)(h, l || c);
    },
    async merchantUserV2QueryByCorpUserId(t, o, r, e) {
      var s, l;
      const h = await n.merchantUserV2QueryByCorpUserId(t, o, r, e), c = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, d = (l = m["MerchantUserApi.merchantUserV2QueryByCorpUserId"]) === null || l === void 0 || (l = l[c]) === null || l === void 0 ? void 0 : l.url;
      return (y, B) => V(h, O, U, a)(y, d || B);
    },
    async merchantUserV2QueryInfoByCorpUserId(t, o, r, e) {
      var s, l;
      const h = await n.merchantUserV2QueryInfoByCorpUserId(t, o, r, e), c = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, d = (l = m["MerchantUserApi.merchantUserV2QueryInfoByCorpUserId"]) === null || l === void 0 || (l = l[c]) === null || l === void 0 ? void 0 : l.url;
      return (y, B) => V(h, O, U, a)(y, d || B);
    },
    async merchantUserV2QueryInfoByCorpUserIdV2(t, o, r, e) {
      var s, l;
      const h = await n.merchantUserV2QueryInfoByCorpUserIdV2(t, o, r, e), c = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, d = (l = m["MerchantUserApi.merchantUserV2QueryInfoByCorpUserIdV2"]) === null || l === void 0 || (l = l[c]) === null || l === void 0 ? void 0 : l.url;
      return (y, B) => V(h, O, U, a)(y, d || B);
    },
    async merchantUserV2QueryInfoByUserId(t, o) {
      var r, e;
      const s = await n.merchantUserV2QueryInfoByUserId(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2QueryInfoByUserId"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2SaveWithRole(t, o) {
      var r, e;
      const s = await n.merchantUserV2SaveWithRole(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2SaveWithRole"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2UpdateName(t, o) {
      var r, e;
      const s = await n.merchantUserV2UpdateName(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2UpdateName"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2UpdateWithRole(t, o) {
      var r, e;
      const s = await n.merchantUserV2UpdateWithRole(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2UpdateWithRole"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2VerifyPhone(t, o) {
      var r, e;
      const s = await n.merchantUserV2VerifyPhone(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserV2VerifyPhone"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserV2WhiteOff(t) {
      var o, r;
      const e = await n.merchantUserV2WhiteOff(t), s = (o = a == null ? void 0 : a.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = m["MerchantUserApi.merchantUserV2WhiteOff"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (h, c) => V(e, O, U, a)(h, l || c);
    },
    async merchantUserV2WhiteOffUser(t, o, r, e) {
      var s, l;
      const h = await n.merchantUserV2WhiteOffUser(t, o, r, e), c = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, d = (l = m["MerchantUserApi.merchantUserV2WhiteOffUser"]) === null || l === void 0 || (l = l[c]) === null || l === void 0 ? void 0 : l.url;
      return (y, B) => V(h, O, U, a)(y, d || B);
    },
    async merchantUserVerifyPhone(t, o) {
      var r, e;
      const s = await n.merchantUserVerifyPhone(t, o), l = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = m["MerchantUserApi.merchantUserVerifyPhone"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (c, d) => V(s, O, U, a)(c, h || d);
    },
    async merchantUserWhiteOff(t) {
      var o, r;
      const e = await n.merchantUserWhiteOff(t), s = (o = a == null ? void 0 : a.serverIndex) !== null && o !== void 0 ? o : 0, l = (r = m["MerchantUserApi.merchantUserWhiteOff"]) === null || r === void 0 || (r = r[s]) === null || r === void 0 ? void 0 : r.url;
      return (h, c) => V(e, O, U, a)(h, l || c);
    },
    async merchantUserWhiteOffUser(t, o, r, e) {
      var s, l;
      const h = await n.merchantUserWhiteOffUser(t, o, r, e), c = (s = a == null ? void 0 : a.serverIndex) !== null && s !== void 0 ? s : 0, d = (l = m["MerchantUserApi.merchantUserWhiteOffUser"]) === null || l === void 0 || (l = l[c]) === null || l === void 0 ? void 0 : l.url;
      return (y, B) => V(h, O, U, a)(y, d || B);
    }
  };
}, x = function(a, n, t) {
  const o = p(a);
  return {
    merchantUserAdd(r, e) {
      return o.merchantUserAdd(r.merchantUserDTO, e).then((s) => s(t, n));
    },
    merchantUserApplyShop(r, e) {
      return o.merchantUserApplyShop(r.merchantUserShopApplyVO, e).then((s) => s(t, n));
    },
    merchantUserBind(r, e) {
      return o.merchantUserBind(r.shopId, r.merchantUserBindVO, e).then((s) => s(t, n));
    },
    merchantUserBindManager(r, e) {
      return o.merchantUserBindManager(r.shopId, r.merchantUserBindVO, e).then((s) => s(t, n));
    },
    merchantUserBindManagerWithWxPhone(r, e) {
      return o.merchantUserBindManagerWithWxPhone(r.shopId, r.merchantUserWxPhoneManagerBindRequest, e).then((s) => s(t, n));
    },
    merchantUserBindWithWxPhone(r, e) {
      return o.merchantUserBindWithWxPhone(r.shopId, r.merchantUserWxPhoneBindRequest, e).then((s) => s(t, n));
    },
    merchantUserChangeBind(r, e) {
      return o.merchantUserChangeBind(r.shopId, r.changeUserBindCommand, e).then((s) => s(t, n));
    },
    merchantUserClearCache(r, e) {
      return o.merchantUserClearCache(r.corpUserId, e).then((s) => s(t, n));
    },
    merchantUserDeleteById(r, e) {
      return o.merchantUserDeleteById(r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserEdit(r, e) {
      return o.merchantUserEdit(r.merchantUserDTO, e).then((s) => s(t, n));
    },
    merchantUserEditStatus(r, e) {
      return o.merchantUserEditStatus(r.merchantUserEditVO, e).then((s) => s(t, n));
    },
    merchantUserGetBindStatus(r, e) {
      return o.merchantUserGetBindStatus(r.shopId, e).then((s) => s(t, n));
    },
    merchantUserGetPage(r, e) {
      return o.merchantUserGetPage(r.merchantUser, r.page, e).then((s) => s(t, n));
    },
    merchantUserGetSuperAdmin(r, e) {
      return o.merchantUserGetSuperAdmin(r.shopId, e).then((s) => s(t, n));
    },
    merchantUserGetUserDetailListByShopId(r, e) {
      return o.merchantUserGetUserDetailListByShopId(r.shopId, e).then((s) => s(t, n));
    },
    merchantUserGetUserListByRoleId(r, e) {
      return o.merchantUserGetUserListByRoleId(r.roleId, e).then((s) => s(t, n));
    },
    merchantUserGetUserListByShopId(r, e) {
      return o.merchantUserGetUserListByShopId(r.shopId, r.requestBody, e).then((s) => s(t, n));
    },
    merchantUserGetUserRolesInfo(r) {
      return o.merchantUserGetUserRolesInfo(r).then((e) => e(t, n));
    },
    merchantUserGetUserShopInfo(r) {
      return o.merchantUserGetUserShopInfo(r).then((e) => e(t, n));
    },
    merchantUserHasLoginPermission(r, e) {
      return o.merchantUserHasLoginPermission(r.corpUserId, e).then((s) => s(t, n));
    },
    merchantUserIsOpenShop(r) {
      return o.merchantUserIsOpenShop(r).then((e) => e(t, n));
    },
    merchantUserQueryByCorpUserId(r, e) {
      return o.merchantUserQueryByCorpUserId(r.corpUserId, r.shopId, r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserQueryById(r, e) {
      return o.merchantUserQueryById(r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserQueryInfoByCorpUserId(r, e) {
      return o.merchantUserQueryInfoByCorpUserId(r.corpUserId, r.shopId, r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserQueryInfoByCorpUserIdV2(r, e) {
      return o.merchantUserQueryInfoByCorpUserIdV2(r.corpUserId, r.shopId, r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserQueryInfoByUserId(r, e) {
      return o.merchantUserQueryInfoByUserId(r.userId, e).then((s) => s(t, n));
    },
    merchantUserSaveWithRole(r, e) {
      return o.merchantUserSaveWithRole(r.merchantUserCreateVo, e).then((s) => s(t, n));
    },
    merchantUserUpdateName(r, e) {
      return o.merchantUserUpdateName(r.merchantUserDTO, e).then((s) => s(t, n));
    },
    merchantUserUpdateWithRole(r, e) {
      return o.merchantUserUpdateWithRole(r.merchantUserCreateVo, e).then((s) => s(t, n));
    },
    merchantUserV2ApplyShop(r, e) {
      return o.merchantUserV2ApplyShop(r.merchantUserShopApplyCommand, e).then((s) => s(t, n));
    },
    merchantUserV2Bind(r, e) {
      return o.merchantUserV2Bind(r.shopId, r.merchantUserBindCommand, e).then((s) => s(t, n));
    },
    merchantUserV2BindManager(r, e) {
      return o.merchantUserV2BindManager(r.shopId, r.merchantUserBindCommand, e).then((s) => s(t, n));
    },
    merchantUserV2DeleteById(r, e) {
      return o.merchantUserV2DeleteById(r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserV2Edit(r, e) {
      return o.merchantUserV2Edit(r.merchantUserDTO, e).then((s) => s(t, n));
    },
    merchantUserV2EditStatus(r, e) {
      return o.merchantUserV2EditStatus(r.userUpdateStatusCommand, e).then((s) => s(t, n));
    },
    merchantUserV2GetBindStatus(r, e) {
      return o.merchantUserV2GetBindStatus(r.shopId, e).then((s) => s(t, n));
    },
    merchantUserV2GetPage(r, e) {
      return o.merchantUserV2GetPage(r.merchantUserDTO, r.page, e).then((s) => s(t, n));
    },
    merchantUserV2GetSuperAdmin(r, e) {
      return o.merchantUserV2GetSuperAdmin(r.shopId, e).then((s) => s(t, n));
    },
    merchantUserV2GetUserDetailListByShopId(r, e) {
      return o.merchantUserV2GetUserDetailListByShopId(r.shopId, e).then((s) => s(t, n));
    },
    merchantUserV2GetUserListByRoleId(r, e) {
      return o.merchantUserV2GetUserListByRoleId(r.roleId, e).then((s) => s(t, n));
    },
    merchantUserV2GetUserListByShopId(r, e) {
      return o.merchantUserV2GetUserListByShopId(r.shopId, r.requestBody, e).then((s) => s(t, n));
    },
    merchantUserV2GetUserRolesInfo(r) {
      return o.merchantUserV2GetUserRolesInfo(r).then((e) => e(t, n));
    },
    merchantUserV2GetUserShopInfo(r) {
      return o.merchantUserV2GetUserShopInfo(r).then((e) => e(t, n));
    },
    merchantUserV2HasLoginPermission(r, e) {
      return o.merchantUserV2HasLoginPermission(r.corpUserId, e).then((s) => s(t, n));
    },
    merchantUserV2IsOpenShop(r) {
      return o.merchantUserV2IsOpenShop(r).then((e) => e(t, n));
    },
    merchantUserV2QueryByCorpUserId(r, e) {
      return o.merchantUserV2QueryByCorpUserId(r.corpUserId, r.shopId, r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserV2QueryInfoByCorpUserId(r, e) {
      return o.merchantUserV2QueryInfoByCorpUserId(r.corpUserId, r.shopId, r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserV2QueryInfoByCorpUserIdV2(r, e) {
      return o.merchantUserV2QueryInfoByCorpUserIdV2(r.corpUserId, r.shopId, r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserV2QueryInfoByUserId(r, e) {
      return o.merchantUserV2QueryInfoByUserId(r.userId, e).then((s) => s(t, n));
    },
    merchantUserV2SaveWithRole(r, e) {
      return o.merchantUserV2SaveWithRole(r.userCreateCommand, e).then((s) => s(t, n));
    },
    merchantUserV2UpdateName(r, e) {
      return o.merchantUserV2UpdateName(r.userUpdateNameCommand, e).then((s) => s(t, n));
    },
    merchantUserV2UpdateWithRole(r, e) {
      return o.merchantUserV2UpdateWithRole(r.userUpdateCommand, e).then((s) => s(t, n));
    },
    merchantUserV2VerifyPhone(r, e) {
      return o.merchantUserV2VerifyPhone(r.phone, e).then((s) => s(t, n));
    },
    merchantUserV2WhiteOff(r) {
      return o.merchantUserV2WhiteOff(r).then((e) => e(t, n));
    },
    merchantUserV2WhiteOffUser(r, e) {
      return o.merchantUserV2WhiteOffUser(r.body, r.shopId, r.merchantUserId, e).then((s) => s(t, n));
    },
    merchantUserVerifyPhone(r, e) {
      return o.merchantUserVerifyPhone(r.phone, e).then((s) => s(t, n));
    },
    merchantUserWhiteOff(r) {
      return o.merchantUserWhiteOff(r).then((e) => e(t, n));
    },
    merchantUserWhiteOffUser(r, e) {
      return o.merchantUserWhiteOffUser(r.body, r.shopId, r.merchantUserId, e).then((s) => s(t, n));
    }
  };
}, b = class extends _ {
  merchantUserAdd(a, n) {
    return p(this.configuration).merchantUserAdd(a.merchantUserDTO, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserApplyShop(a, n) {
    return p(this.configuration).merchantUserApplyShop(a.merchantUserShopApplyVO, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserBind(a, n) {
    return p(this.configuration).merchantUserBind(a.shopId, a.merchantUserBindVO, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserBindManager(a, n) {
    return p(this.configuration).merchantUserBindManager(a.shopId, a.merchantUserBindVO, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserBindManagerWithWxPhone(a, n) {
    return p(this.configuration).merchantUserBindManagerWithWxPhone(a.shopId, a.merchantUserWxPhoneManagerBindRequest, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserBindWithWxPhone(a, n) {
    return p(this.configuration).merchantUserBindWithWxPhone(a.shopId, a.merchantUserWxPhoneBindRequest, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserChangeBind(a, n) {
    return p(this.configuration).merchantUserChangeBind(a.shopId, a.changeUserBindCommand, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserClearCache(a, n) {
    return p(this.configuration).merchantUserClearCache(a.corpUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserDeleteById(a, n) {
    return p(this.configuration).merchantUserDeleteById(a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserEdit(a, n) {
    return p(this.configuration).merchantUserEdit(a.merchantUserDTO, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserEditStatus(a, n) {
    return p(this.configuration).merchantUserEditStatus(a.merchantUserEditVO, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserGetBindStatus(a, n) {
    return p(this.configuration).merchantUserGetBindStatus(a.shopId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserGetPage(a, n) {
    return p(this.configuration).merchantUserGetPage(a.merchantUser, a.page, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserGetSuperAdmin(a, n) {
    return p(this.configuration).merchantUserGetSuperAdmin(a.shopId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserGetUserDetailListByShopId(a, n) {
    return p(this.configuration).merchantUserGetUserDetailListByShopId(a.shopId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserGetUserListByRoleId(a, n) {
    return p(this.configuration).merchantUserGetUserListByRoleId(a.roleId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserGetUserListByShopId(a, n) {
    return p(this.configuration).merchantUserGetUserListByShopId(a.shopId, a.requestBody, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserGetUserRolesInfo(a) {
    return p(this.configuration).merchantUserGetUserRolesInfo(a).then((n) => n(this.axios, this.basePath));
  }
  merchantUserGetUserShopInfo(a) {
    return p(this.configuration).merchantUserGetUserShopInfo(a).then((n) => n(this.axios, this.basePath));
  }
  merchantUserHasLoginPermission(a, n) {
    return p(this.configuration).merchantUserHasLoginPermission(a.corpUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserIsOpenShop(a) {
    return p(this.configuration).merchantUserIsOpenShop(a).then((n) => n(this.axios, this.basePath));
  }
  merchantUserQueryByCorpUserId(a, n) {
    return p(this.configuration).merchantUserQueryByCorpUserId(a.corpUserId, a.shopId, a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserQueryById(a, n) {
    return p(this.configuration).merchantUserQueryById(a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserQueryInfoByCorpUserId(a, n) {
    return p(this.configuration).merchantUserQueryInfoByCorpUserId(a.corpUserId, a.shopId, a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserQueryInfoByCorpUserIdV2(a, n) {
    return p(this.configuration).merchantUserQueryInfoByCorpUserIdV2(a.corpUserId, a.shopId, a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserQueryInfoByUserId(a, n) {
    return p(this.configuration).merchantUserQueryInfoByUserId(a.userId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserSaveWithRole(a, n) {
    return p(this.configuration).merchantUserSaveWithRole(a.merchantUserCreateVo, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserUpdateName(a, n) {
    return p(this.configuration).merchantUserUpdateName(a.merchantUserDTO, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserUpdateWithRole(a, n) {
    return p(this.configuration).merchantUserUpdateWithRole(a.merchantUserCreateVo, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2ApplyShop(a, n) {
    return p(this.configuration).merchantUserV2ApplyShop(a.merchantUserShopApplyCommand, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2Bind(a, n) {
    return p(this.configuration).merchantUserV2Bind(a.shopId, a.merchantUserBindCommand, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2BindManager(a, n) {
    return p(this.configuration).merchantUserV2BindManager(a.shopId, a.merchantUserBindCommand, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2DeleteById(a, n) {
    return p(this.configuration).merchantUserV2DeleteById(a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2Edit(a, n) {
    return p(this.configuration).merchantUserV2Edit(a.merchantUserDTO, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2EditStatus(a, n) {
    return p(this.configuration).merchantUserV2EditStatus(a.userUpdateStatusCommand, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2GetBindStatus(a, n) {
    return p(this.configuration).merchantUserV2GetBindStatus(a.shopId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2GetPage(a, n) {
    return p(this.configuration).merchantUserV2GetPage(a.merchantUserDTO, a.page, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2GetSuperAdmin(a, n) {
    return p(this.configuration).merchantUserV2GetSuperAdmin(a.shopId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2GetUserDetailListByShopId(a, n) {
    return p(this.configuration).merchantUserV2GetUserDetailListByShopId(a.shopId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2GetUserListByRoleId(a, n) {
    return p(this.configuration).merchantUserV2GetUserListByRoleId(a.roleId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2GetUserListByShopId(a, n) {
    return p(this.configuration).merchantUserV2GetUserListByShopId(a.shopId, a.requestBody, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2GetUserRolesInfo(a) {
    return p(this.configuration).merchantUserV2GetUserRolesInfo(a).then((n) => n(this.axios, this.basePath));
  }
  merchantUserV2GetUserShopInfo(a) {
    return p(this.configuration).merchantUserV2GetUserShopInfo(a).then((n) => n(this.axios, this.basePath));
  }
  merchantUserV2HasLoginPermission(a, n) {
    return p(this.configuration).merchantUserV2HasLoginPermission(a.corpUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2IsOpenShop(a) {
    return p(this.configuration).merchantUserV2IsOpenShop(a).then((n) => n(this.axios, this.basePath));
  }
  merchantUserV2QueryByCorpUserId(a, n) {
    return p(this.configuration).merchantUserV2QueryByCorpUserId(a.corpUserId, a.shopId, a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2QueryInfoByCorpUserId(a, n) {
    return p(this.configuration).merchantUserV2QueryInfoByCorpUserId(a.corpUserId, a.shopId, a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2QueryInfoByCorpUserIdV2(a, n) {
    return p(this.configuration).merchantUserV2QueryInfoByCorpUserIdV2(a.corpUserId, a.shopId, a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2QueryInfoByUserId(a, n) {
    return p(this.configuration).merchantUserV2QueryInfoByUserId(a.userId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2SaveWithRole(a, n) {
    return p(this.configuration).merchantUserV2SaveWithRole(a.userCreateCommand, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2UpdateName(a, n) {
    return p(this.configuration).merchantUserV2UpdateName(a.userUpdateNameCommand, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2UpdateWithRole(a, n) {
    return p(this.configuration).merchantUserV2UpdateWithRole(a.userUpdateCommand, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2VerifyPhone(a, n) {
    return p(this.configuration).merchantUserV2VerifyPhone(a.phone, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserV2WhiteOff(a) {
    return p(this.configuration).merchantUserV2WhiteOff(a).then((n) => n(this.axios, this.basePath));
  }
  merchantUserV2WhiteOffUser(a, n) {
    return p(this.configuration).merchantUserV2WhiteOffUser(a.body, a.shopId, a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserVerifyPhone(a, n) {
    return p(this.configuration).merchantUserVerifyPhone(a.phone, n).then((t) => t(this.axios, this.basePath));
  }
  merchantUserWhiteOff(a) {
    return p(this.configuration).merchantUserWhiteOff(a).then((n) => n(this.axios, this.basePath));
  }
  merchantUserWhiteOffUser(a, n) {
    return p(this.configuration).merchantUserWhiteOffUser(a.body, a.shopId, a.merchantUserId, n).then((t) => t(this.axios, this.basePath));
  }
};
export {
  b as MerchantUserApi,
  P as MerchantUserApiAxiosParamCreator,
  x as MerchantUserApiFactory,
  p as MerchantUserApiFp
};

//# sourceMappingURL=merchant-user-api.js.map